import { customFetch } from "@/client/custom-fetch";

import type {
  TWhatsappConversationThread,
  TWhatsappMessagesPage,
} from "./partner-whatsapp-inbox.types";

function orgHeaders(organizationId: string): Record<string, string> {
  return { "x-organization-id": organizationId.trim() };
}

export function listWhatsappConversations(
  organizationId: string,
  params?: { search?: string; limit?: number },
): Promise<TWhatsappConversationThread[]> {
  const qs = new URLSearchParams();
  if (params?.search?.trim()) {
    qs.set("search", params.search.trim());
  }
  if (params?.limit != null) {
    qs.set("limit", String(params.limit));
  }
  const query = qs.toString();
  const path = `/organizations/${organizationId}/whatsapp/conversations${
    query ? `?${query}` : ""
  }`;
  return customFetch<TWhatsappConversationThread[]>(path, {
    method: "GET",
    headers: orgHeaders(organizationId),
    skipLoading: true,
  });
}

export function listWhatsappConversationMessages(
  organizationId: string,
  threadId: string,
  params?: { limit?: number; since?: string },
): Promise<TWhatsappMessagesPage> {
  const qs = new URLSearchParams();
  if (params?.limit != null) {
    qs.set("limit", String(params.limit));
  }
  if (params?.since) {
    qs.set("since", params.since);
  }
  const query = qs.toString();
  const path = `/organizations/${organizationId}/whatsapp/conversations/${threadId}/messages${
    query ? `?${query}` : ""
  }`;
  return customFetch<TWhatsappMessagesPage>(path, {
    method: "GET",
    headers: orgHeaders(organizationId),
    skipLoading: true,
  });
}
